import PropTypes from 'prop-types'
import { useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import EventEmitter, { SHOW_POPUP_ERROR } from '../../helpers/EventEmitter'
import {
  selectComponentAuthorized,
  selectUserType,
} from '../../layout/store/slice'
import { AUTHORIZATION_TYPE } from '../../utils/authorization'
import { Icon } from '../html/icon'
import { GROUP_CLASS_NAME } from './constants'
import { getLayoutData } from './helper'

const MIN_TOTAL_LAYOUT = 1

export const PanelDelete = ({ changeLayout }) => {
  const userType = useSelector(selectUserType)

  const AUTHORIZATION_API = useSelector(selectComponentAuthorized)
  const onClick = (e) => {
    const parentEl = e.target.closest('#parentId')
    const el = e.target.closest('.' + GROUP_CLASS_NAME)
    const oldLayout = getLayoutData(parentEl)

    if (oldLayout.length > MIN_TOTAL_LAYOUT) {
      el.remove()
      changeLayout(getLayoutData(parentEl))
    } else {
      EventEmitter.dispatch(SHOW_POPUP_ERROR, {
        messages: [
          <Translate value="preferenceSetting.WARNING_DELETE_PANEL" />,
        ],
      })
    }
  }

  return (
    AUTHORIZATION_API.companyAnalysis.deletePanel[userType.userTypeId] ===
      AUTHORIZATION_TYPE.ALLOW && (
      <Icon
        className="icon-delete"
        style={{ color: '#9C9C9C' }}
        onClick={onClick}
      />
    )
  )
}

PanelDelete.propTypes = {
  changeLayout: PropTypes.func,
}

PanelDelete.defaultProps = {
  changeLayout: () => {},
}
